module.exports = __webpack_public_path__ + "packs/media/images/not_found-482f1f9efafe87b489978ec1f72d25b6.jpg";